/* eslint-disable import/no-useless-path-segments */
import { ArrowRight } from 'iconsax-react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import googleImg from '../../assets/images/google.svg';
import Button from '../../assets/styles/Button';
import Spinner from '../../assets/styles/spinner';
import Text from '../../assets/styles/Text';

import * as styles from './styles';

export default function FormAuth({
  onSubmit,
  onGoogle = null,
  googleText = null,
  children,
  buttonTitle,
  next = false,
  buttonLinkText = null,
  buttonLink = null,
  twoButtons = false,
  isLoading,
  formValid,
}) {
  const hasGoogle = onGoogle && googleText;
  const hasLink = buttonLink && buttonLinkText;

  function handleSubmit(e) {
    e.preventDefault();
    e.stopPropagation();

    if (formValid && !isLoading) {
      onSubmit(e);
    }
  }

  return (
    <styles.Form onSubmit={handleSubmit}>
      {hasGoogle && (
        <styles.ButtonGoogle onClick={onGoogle}>
          <img src={googleImg} alt="google" />
          <Text.P>{googleText}</Text.P>
        </styles.ButtonGoogle>
      )}

      {twoButtons && (
        <Button
          type="submit"
          className="two-buttons"
          $padding={isLoading ? 4 : 20}
          $radius={16}
          disabled={!formValid || isLoading}
        >
          {isLoading && <Spinner size={48} />}

          {!isLoading && (
            <>
              <Text.P $bold>{buttonTitle}</Text.P>
              {next && <ArrowRight />}
            </>
          )}
        </Button>
      )}

      {children}

      <styles.GroupButton>
        {!twoButtons && (
          <Button
            type="submit"
            disabled={!formValid || isLoading}
            $padding={isLoading ? 4 : 20}
            $radius={16}
          >
            {isLoading && <Spinner size={48} />}

            {!isLoading && (
              <>
                <Text.P $bold>{buttonTitle}</Text.P>
                {next && <ArrowRight />}
              </>
            )}
          </Button>
        )}

        {twoButtons && (
          <Button
            type="submit"
            $padding={isLoading ? 4 : 20}
            $radius={16}
            disabled={!formValid || isLoading}
          >
            {isLoading && <Spinner size={48} />}

            {!isLoading && (
              <>
                <Text.P $bold>{buttonTitle}</Text.P>
                {next && <ArrowRight />}
              </>
            )}
          </Button>
        )}

        {hasLink && <Link to={buttonLink}>{buttonLinkText}</Link>}
      </styles.GroupButton>
    </styles.Form>
  );
}

FormAuth.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onGoogle: PropTypes.func,
  googleText: PropTypes.string,
  children: PropTypes.node.isRequired,
  next: PropTypes.bool,
  buttonTitle: PropTypes.string.isRequired,
  buttonLinkText: PropTypes.string,
  buttonLink: PropTypes.string,
  isLoading: PropTypes.bool,
  twoButtons: PropTypes.bool,
  formValid: PropTypes.bool.isRequired,
};
